import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Common.css';

// Import local images - replace with your actual image paths
import doctorImage from '../assets/images/about1.png';
import medicalRoomImage from '../assets/images/about2.jpg';

const About = ({ onNavigate }) => {
  const handleContactClick = () => {
    if (onNavigate) {
      onNavigate('contact');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className="about-page">
      {/* Top About Section */}
      <section className="top-about-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <span className="section-label">About</span>
              <h2 className="section-title">Ready to Equip Your Healthcare Vision?</h2>
              <p className="section-text">
                At Orthomed, we provide top-quality medical equipment and supplies tailored to healthcare professionals’ needs, ensuring efficiency and reliability. With a focus on exceptional service and trusted partnerships, we deliver the best solutions at competitive prices.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="who-we-are-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <img 
                src={doctorImage}
                alt="Medical professional" 
                className="doctor-image"
              />
            </div>
            <div className="col-lg-6">
              <span className="section-label-small">Best Medical Products</span>
              <h2 className="who-title">Who We Are</h2>
              <p className="who-text">
               Orthomed Products is a trusted provider of medical equipment and supplies, dedicated to serving the needs of healthcare professionals across various fields. With a focus on quality, affordability, and efficiency, we connect clinics, hospitals, and practitioners with top-tier products from renowned manufacturers.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="vision-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <span className="section-label">About</span>
              <h2 className="section-title">Ready to Equip Your Healthcare Vision?</h2>
              <p className="section-text">
             At Orthomed Products, we believe that the right tools can transform your healthcare practice. Whether you’re a small clinic or a large hospital, our mission is to equip you with the best medical supplies that align with your vision of excellence. Our extensive range of products is designed to enhance patient care, improve efficiency, and meet the highest standards of the healthcare industry.
              </p>
              <button className="btn-secondary-custom" onClick={handleContactClick}>
                Contact now
              </button>
            </div>
            <div className="col-lg-6">
              <img 
                src={medicalRoomImage}
                alt="Medical room" 
                className="vision-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-box">
            <div className="row align-items-center">
              <div className="col-lg-8 mb-3 mb-lg-0">
                <h3 className="cta-title">Contact us today to learn more about our products.</h3>
              </div>
              <div className="col-lg-4 text-lg-end">
                <button className="btn-cta" onClick={handleContactClick}>
                  Contact Us Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;